import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { sortBy } from 'lodash'
import IndicatorPiezometer from '../indicator/IndicatorPiezometer'
import HistoryChartPanel from './HistoryChartPanel'
import AnnualChartPanel from './AnnualChartPanel'
import AverageLevelChartPanel from './AverageLevelChartPanel'
import DtoDetailPiezometerMeasure from '../../dto/DtoDetailPiezometerMeasure'
import DtoPiezometerMeasure from '../../../dashboard/dto/DtoPiezometerMeasure'

class PiezometerPanel extends Component {

	getPiezometerMeasures = () => {
		return sortBy(this.props.piezometerMeasures, ['date'])
	}
	getPiezometerMeasureYearChart = () => {
		if (this.getPiezometerMeasures().length > 0) {
			return (
				<AnnualChartPanel piezometerMeasures={ this.getPiezometerMeasures() }
								  piezometerMeasuresMax={ this.props.piezometerMeasuresMax }
								  piezometerMeasuresMin={ this.props.piezometerMeasuresMin }
								  piezometerMeasuresMoyenne={ this.props.piezometerMeasuresMoyenne }
				/>
			)
		}
		return null
	}
	getPiezometerMeasureHistoryChart = () => {
		if (this.getPiezometerMeasures().length > 0) {
			return (
				<HistoryChartPanel piezometerMeasures={ this.getPiezometerMeasures() }/>
			)
		}
		return null
	}
	getAverageLevelChartPanel = () => {
		if (this.getPiezometerMeasures().length > 0) {
			return (
				<AverageLevelChartPanel piezometerMeasures={ this.getPiezometerMeasures() }/>
			)
		}
		return null
	}

	render() {
		return (
			<div className='row no-margin card-title'>
				<div className='col s12 m12 l12 '>
					<div className='row no-margin white-background'>
						<div className='col s12 m12 l12 no-padding card-title hide-on-med-and-down no-margin'>
							<IndicatorPiezometer/>
						</div>
					</div>
					<div className='row no-margin white-background'>
						<div className='col s12 m12 l8 card-title hide-on-med-and-down'>
							{ this.getPiezometerMeasureYearChart() }
						</div>
						<div className='col s12 m12 l4 card-title hide-on-med-and-down'>
							<div className='row no-margin'>
								<div className='col s12 no-padding'>
									{ this.getPiezometerMeasureHistoryChart() }
								</div>
								<div className='col s12 no-padding'>
									{ this.getAverageLevelChartPanel() }
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

PiezometerPanel.propTypes = {
	id: PropTypes.string,
	piezometerMeasuresMax: PropTypes.arrayOf(DtoDetailPiezometerMeasure),
	piezometerMeasuresMin: PropTypes.arrayOf(DtoDetailPiezometerMeasure),
	piezometerMeasuresMoyenne: PropTypes.arrayOf(DtoDetailPiezometerMeasure),
	piezometerMeasures: PropTypes.arrayOf(DtoPiezometerMeasure)

}

const mapStateToProps = store => {
	return {
		piezometerMeasuresMax: store.DetailStationReducer.piezometerMeasuresMax,
		piezometerMeasuresMin: store.DetailStationReducer.piezometerMeasuresMin,
		piezometerMeasuresMoyenne: store.DetailStationReducer.piezometerMeasuresMoyenne,
		piezometerMeasures: store.DetailStationReducer.piezometerMeasures
	}
}

export default connect(mapStateToProps)(PiezometerPanel)



// WEBPACK FOOTER //
// ./src/station/components/piezometer/PiezometerPanel.js